import styled from 'styled-components';
import CornCropBG from 'assets/images/cornBackgroundImage.png';
import SunflowerCropBG from 'assets/images/Sunflower.png';
import BarleyCropBG from 'assets/images/Barley_BG.png';
import WheatCropBG from 'assets/images/Wheat_BG.png';
import SoyabeanCropBG from 'assets/images/Soyabean_BG.png';

interface HeroBanner0bWrapperProps {
  cropName?: string;
}

export const HeroBanner0bWrapper = styled.div<{ cropName: string } & HeroBanner0bWrapperProps>`
  background-repeat: no-repeat;
  position: relative;
  background-size: cover;
  background: var(--Neutral-neutral-100, #14151C);
  width: 100%;
  text-align: center;
  color: #fff;

  .white-dot {
    width: 6px;
    height: 6px;
    background-color: white;
    border-radius: 50%;
    margin: 0px 8px;
  }
  .icon-size {
    width: 16px;
    height: 16px;
  }
  .field-image {
    margin-right: 6px;
  }
  .separator-icon {
    width: 1px;
    height: 16px;
    margin: 0 16px;
  }
  .crop-icon {
    margin-right: 8px;
  }
  .leaflet-image {
    position: absolute;
    right: 64px;
    top: 40px;
  }
  .icon-padding {
    padding: 0px 6px;
  }
  .calendar-icon {
    margin-right: 8px;
  }
  .user-details-mobile {
    display: flex;
    align-items: flex-start;
    margin-top: 10px;
  }
  .user-details-desktop {
    display: flex;
  }
  .user-details-text {
    display: inline-block;
    word-wrap: break-word;
    max-width: 148px;
    margin-top: -5px;
    text-align: left;
  }
  .contact-details-mobile {
    display: flex;
    align-items: flex-start;
  }
  .contact-details-desktop {
    display: flex;
    align-items: center;
  }
  .text-link {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

interface IsMobileProps {
  isMobile: boolean;
}

export const HeroBanner0bSection = styled.div<IsMobileProps>`
  display: flex;
  flex-direction: column;
  padding: ${({ isMobile }) => (isMobile ? '32px 20px' : '40px 64px')};
  position: relative;
`;

export const CollapsibleHeader = styled.div<{ isExpanded?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: ${({ isExpanded }) => (isExpanded ? '16px' : '8px')};
`;

export const HeaderTitle = styled.h2`
  color: var(--Neutral-neutral-00, #fff);

  /* Default / Body Med - 16px | 24px */
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.12px;
`;

export const ExpandedContent = styled.div<{ isExpanded?: boolean }>`
  max-height: ${({ isExpanded }) => (isExpanded ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
  margin-bottom: ${({ isExpanded }) => (isExpanded ? '24px' : '0')};
`;

export const UserDetailsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  flex-wrap: wrap;

  .user-detail-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  img {
    width: 16px;
    height: 16px;
  }

  a {
    color: #fff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .separator-icon {
    width: 1px;
    height: 16px;
    margin: 0 8px;
  }
`;

export const HeroBanner0bTitle = styled.div`
  width: max-content;
  padding: 2px 4px;
  font-weight: 600;
  line-height: 16px;
  border-radius: 4px;
  background: rgba(35, 38, 48, 0.5);
`;

export const HeroBanner0bTitleNonDDG = styled.div`
  width: max-content;
  padding: 2px 4px;
  font-weight: 600;
  line-height: 38px;
  font-size: 30px;
  display: table-footer-group;
  text-align: left;
`;

export const HeroBanner0bUserName = styled.h3`
  font-size: 30px;
  font-weight: 600;
  line-height: 38px;
  border-radius: 4px;
  text-align: justify;
  margin: 0;
  color: #fff;
`;

export const HeroBanner0bDate = styled.div`
  width: max-content;
  min-width: 242px;
  height: 31px;
  border-radius: 26px 0px;
  background: var(--Neutral-neutral-100, #14151C);
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0px 19px;
  margin-top: 12px;
`;

export const HeroBanner0bUserDetailsNonDDG = styled.div<IsMobileProps>`
  width: max-content;
  padding: 2px 4px;
  font-weight: 500;
  margin-top: 15px;
  line-height: 24px;
  font-size: 16px;
  display: ${({ isMobile }) => !isMobile && 'flex'};
`;

export const HeroBanner0bFieldInfo = styled.div`
  border-radius: 8px;
  border: 1px solid var(--Border-Default-Border-Default-Disabled-Primary, #c2c7d0);
  display: flex;
  font-size: 16px;
  padding: 12px 12px;
  align-items: center;
  justify-content: center;
  width: max-content;
  margin: 24px 0px;
`;

export const HeroBanner0bFieldInfoMobilePrimary = styled(HeroBanner0bFieldInfo)`
  border-radius: 8px 8px 0px 0px;
  width: auto;
  margin: 0px;
`;

export const HeroBanner0bFieldInfoMobileSecondary = styled(HeroBanner0bFieldInfo)`
  border-radius: 0 0 8px 8px;
  width: auto;
  margin: 0px;
`;

export const HeroBanner0bFieldInfoContainer = styled.div`
  padding: 0px;
`;

export const HeroBanner0bReportOverview = styled.div<{ isExpanded?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin-top: 15px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  border: 2px solid var(--Neutral-neutral-30, #c2c7d0);
  background: rgba(35, 38, 48, 0.25);
  backdrop-filter: blur(5px);
  cursor: pointer;
  transition: all 0.3s ease;
`;

export const IconBox = styled.span`
  border-radius: 6px;
  background: rgba(105, 111, 136, 0.5);
  display: flex;
  width: 24px;
  height: 24px;
  padding: 6.75px 4.836px 4.25px 4.164px;
  justify-content: center;
  align-items: center;
`;

export const StyledHeaderText = styled.span`
  font-family: 'Noto Sans';
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: -0.375px;
  text-align: left;
`;

export const StyledHeaderSmallText = styled.span`
  display: flex;
  font-family: 'Noto Sans';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.15px;
  text-align: left;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StyledHeaderVerySmallText = styled.span<{ isExpanded?: boolean }>`
  font-family: 'Noto Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.12px;
  text-align: left;
  white-space: pre-line;
  display: ${({ isExpanded }) => (isExpanded ? 'block' : 'none')};

  &::after {
    content: ' ';
  }
`;

export const ExpandIcon = styled.span<{ isExpanded?: boolean }>`
  transition: transform 0.3s ease;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'rotate(0deg)')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FieldInfoWrapper = styled.div`
  width: 100%;
`;

export const FieldInfoTopRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #c2c7d0;
`;

export const FieldInfoBottomRow = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
`;

export const UserIntroText = styled.div`
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;

export const ReportOverviewHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const IconBoxWrapper = styled.div`
  padding-left: 8px;
`;
